import React, { useEffect, useState } from "react";
import expenseService from "../../services/owner-services/owner-property-expense";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Row, Col, Form } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
const NATURE_OF_EXPENSE_OPTIONS = [
  "Electricity expense",
  "Water expense",
  "Maintenance expense",
  "Internet expense",
  "Cleaning expense",
  "Security expense",
  "Parking expense",
  "Pest control expense",
  "Insurance expense",
  "Repair expense",
  "Painting materials",
  "Painter wages",
  "Porter Charges",
  "Offline Marketing",
  "Owner adjusted Rent/SD",
];

const MyExpense = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [natureOfExpense, setNatureOfExpense] = useState("");

  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), 1);
  });

  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() + 1, 0);
  });

  useEffect(() => {
    fetchAuditData();
  }, [natureOfExpense, startDate, endDate]);

  const formatDate = (dateObj) => dateObj.toISOString().split("T")[0];

  const fetchAuditData = async () => {
    setLoading(true);
    try {
      const payload = {
        pageLenght: 100,
        pageNo: 1,
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        propertyGuid: "",
        natureOfExpense,
      };

      const response = await expenseService.posttPropertyExpense(payload);
      if (response?.data?.isSuccess) {
        const list = response.data.result;
        setData(Array.isArray(list) ? list : list ? [list] : []);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDated = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/ /g, "-");
  };
  const getLastDayOfMonth = (date) =>
    new Date(date.getFullYear(), date.getMonth() + 1, 0);
  console.log("data",data)
  return (
    <div>
      <h3>My Expenses</h3>

      <Form className="mb-3 mt-4">
        <Row className="align-items-center">
          <Col sm={3}>
            <Form.Label>From Date</Form.Label>
            <Calendar
              value={startDate}
              onChange={(e) => {
                const newStart = new Date(
                  e.value.getFullYear(),
                  e.value.getMonth(),
                  1
                );
                setStartDate(newStart);
                setEndDate(getLastDayOfMonth(newStart));
              }}
              view="month"
              dateFormat="yy-mm-dd"
              showIcon
              maxDate={new Date()}
              minDate={new Date("2000-01-01")}
            />
          </Col>
          <Col sm={3}>
            <Form.Label>To Date</Form.Label>
            <Calendar
              value={endDate}
              onChange={(e) => {
                const newEnd = getLastDayOfMonth(e.value);
                setEndDate(newEnd);
                setStartDate(
                  new Date(newEnd.getFullYear(), newEnd.getMonth(), 1)
                );
              }}
              view="month"
              dateFormat="yy-mm-dd"
              showIcon
              maxDate={new Date()}
              minDate={new Date("2000-01-01")}
            />
          </Col>
          <Col sm={4}>
            <Form.Label>Nature of Expense</Form.Label>
            <Form.Select
              value={natureOfExpense}
              onChange={(e) => setNatureOfExpense(e.target.value)}
            >
              <option value="">-- Select Nature of Expense --</option>
              {NATURE_OF_EXPENSE_OPTIONS.map((item, idx) => (
                <option key={idx} value={item}>
                  {item}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      </Form>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <Row>
          <Col xs={12}>
            <DataTable
              value={data}
              paginator
              rows={10}
              showGridlines
              stripedRows
            >
              <Column field="natureOfExpense" header="Nature of Expense" />
              <Column field="propertyName" header="Property Name" />
              <Column
                body={(rowData) => formatDated(rowData.expenseDate)}
                header="Date"
              />

              <Column
                header="Amount"
                body={(rowData) =>
                  rowData.amount != null
                    ? `Rs. ${Number(rowData.amount).toLocaleString("en-IN")}`
                    : "-"
                }
              />

              <Column
                body={(rowData) => formatDated(rowData.addedOn)}
                header="Added On"
              />
               <Column field="note" header="Note" />
            </DataTable>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default MyExpense;
